export class RouteTypesData {
  constructor(public origin: string, public destination: string) {}
}
